import React from 'react';
import * as PropTypes from "prop-types";
import { set } from 'immutadot/core';
import {CampaignShortcutSelect} from "../../components/MaterialSelects/CampaignShortcutSelect";
import {NumberField} from "../../components/number-input";
import {Button, Checkbox, FormControlLabel} from "@mui/material";
import {BookingTypeSelect} from "../../components/MaterialSelects/BookingTypeSelect";

const PanelBookingsSidebar = (props)=> {

  const onChange = (evt) => {
    console.log('PANELBOOKINGS CHANGE EVENT TRIGGERED',evt);
    let values = Object.assign({}, props);
    const value = (evt.target.type == 'checkbox') ? !!evt.target.checked : evt.target.value;
    delete(values.changeOptions);
    values = set(values,evt.target.name,value);
    props.changeOptions(values);
//    console.log('set to',values);
  };
  const field = {
      onChange: onChange
  };
  console.log('PANELBOOKINGS render with',props);
  return (
  <div className="panel-bookings__sidebar grid12">
      <CampaignShortcutSelect valueIsId={true} name="campaignId" {...field} value={props.campaignId}  label="Campaign"/>
      <NumberField {...field} value={props.numWeeks} name="numWeeks" label="Number of Weeks"/>
      <BookingTypeSelect {...field} valueIsId={true} name="bookingType" value={props.bookingType} label="Type" />
    <FormControlLabel control={<Checkbox {...field} name="isSlot" checked={props.isSlot} />} label="Slot Booking"/>
    <Button variant="outlined" onClick={props.optionAll}>Option all Panels</Button>
  </div>
  );
}


PanelBookingsSidebar.propTypes = {
  changeOptions:PropTypes.func.isRequired,
  optionAll:PropTypes.func.isRequired,
  bookingType:PropTypes.string,
  campaignId:PropTypes.string,
  isSlot:PropTypes.bool,
  numWeeks:PropTypes.number
};


export default PanelBookingsSidebar;
